import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Allergen, getAllergensForRecipe, recipeName, showQuantity } from "../specCardsHelpers"
import { faFile, faMinus, faPencilAlt, faPlus } from "@fortawesome/free-solid-svg-icons"
import { useState } from "react"

  export const IngredientRow = ({ canEdit, setItem, showCard, toggleEditModal, recipes, recipe, ingredient, multiplier, expanded, quantity, showOriginal }) => {

    

    const [open, setOpen] = useState(false)

    if (!recipes?.length) return ''

    const ingredient_recipe = ingredient.recipe //allRecipes.find(r => r.pid === ingredient.child_pid)
    const ingredientsCount = ingredient_recipe?.ingredients?.length

    const allergens = getAllergensForRecipe(recipes, ingredient_recipe)

    const togglePanel = () => {
      setOpen(!open)
    }

    const handleShowCard = () => {
        showCard(ingredient_recipe.pid)
    }

    const editItem = () => {
      setItem(ingredient_recipe)
      toggleEditModal()
    }

    if (!ingredient_recipe) return <tr><td className='row'>[ item not found ]</td></tr>

    return (
      <tr key={`${recipe.pid}-${ingredient_recipe.pid}`}>
        <td className='row'>

          <div className='quantity'>{showQuantity(ingredient.quantity_adjusted, multiplier, ingredient.quantity_unit)}{showOriginal && multiplier !== 1 ? <div className='orig-quantity'>{showQuantity(ingredient.quantity_adjusted, 1, ingredient.quantity_unit)}</div> : ''}</div>

          <div className='name'>
            <div>{recipeName(ingredient_recipe)} {ingredient_recipe.type === 'P' ? allergens?.map(a => <Allergen name={a} />) : ''}</div>

            {ingredientsCount ? <div className={`${open || expanded ? 'open' : ''} indent`}><IngredientTable canEdit={canEdit} setItem={setItem} showCard={showCard} toggleEditModal={toggleEditModal} recipes={recipes} child expanded={expanded} recipe={ingredient_recipe} multiplier={multiplier} /></div> : ''}
          </div>

          {ingredientsCount ?
            <div className='ingredient-menu'>
              {!expanded ? <button className='inv' onClick={togglePanel}><FontAwesomeIcon icon={open ? faMinus : faPlus} /> {ingredientsCount}</button> : ''}

              <button className='inv' onClick={handleShowCard}><FontAwesomeIcon icon={faFile} /></button>

              {canEdit ? <button className='inv' onClick={editItem}><FontAwesomeIcon icon={faPencilAlt} /></button> : ''}
            </div>
            :
            <div className='ingredient-menu'>
              {canEdit ? <button className='inv' onClick={editItem}><FontAwesomeIcon icon={faPencilAlt} /></button> : ''}
            </div>
          }
        </td>
      </tr>
    )
  }

  export const IngredientTable = ({ canEdit, showCard, setItem, toggleEditModal, recipes, recipe, multiplier, expanded, child, showOriginal }) => {

    return (
      <table>
        {recipe.ingredients.map(i => {
          return <IngredientRow canEdit={canEdit} showCard={showCard} setItem={setItem} toggleEditModal={toggleEditModal} recipes={recipes} recipe={recipe} quantity={i.quantity_adjusted} showOriginal={showOriginal} ingredient={i} multiplier={multiplier} expanded={expanded} />
        })}
        {!child ? <tr>
          <td><Allergens recipes={recipes} recipe={recipe} /></td>
        </tr> : ''}
      </table>
    )
  }

  export const Allergens = ({ recipes, recipe }) => {
    const allergens = getAllergensForRecipe(recipes, recipe)
    return allergens.length ? <div className='allergens-list'><h3>Allergens</h3>{allergens.map(a => <Allergen name={a} />)}</div> : ''
  }
